define.alias("shared/components/shared/button/boost", "preview-grid/components/shared/button/boost");